import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_design-scorecard/artifacts/dmpk6oxa_site%20grade%20pro%20logo%20a.png";

const NAV_LINKS = [
    { key: 'features', label: 'Features' },
    { key: 'seo-tools', label: 'SEO Tools' },
    { key: 'how-it-works', label: 'How It Works' },
    { key: 'pricing', label: 'Pricing' },
    { key: 'about', label: 'About' },
    { key: 'contact', label: 'Contact' },
    { key: 'blog', label: 'Blog' },
];

export function Navbar({ activePage, onNavigate, onRunAudit }) {
    const [open, setOpen] = useState(false);

    const navigate = (page) => {
        setOpen(false);
        onNavigate(page);
    };

    return (
        <nav className="border-b border-white/5 bg-black/80 backdrop-blur-md sticky top-0 z-50" data-testid="page-navbar">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
                <button onClick={() => navigate('home')} className="flex items-center gap-3 hover:opacity-80 transition-opacity">
                    <img src={LOGO_URL} alt="SiteGradePro" className="h-10 w-auto object-contain" />
                </button>
                {/* Desktop */}
                <div className="hidden md:flex items-center gap-6">
                    {NAV_LINKS.map(l => (
                        <button
                            key={l.key}
                            onClick={() => navigate(l.key)}
                            className={l.key === activePage ? 'text-magenta font-medium' : 'text-gray-400 hover:text-white transition-colors'}
                        >
                            {l.label}
                        </button>
                    ))}
                </div>
                <div className="flex items-center gap-3">
                    <button
                        onClick={() => setOpen(!open)}
                        className="md:hidden p-2 text-gray-400 hover:text-white"
                        data-testid="page-mobile-menu-btn"
                    >
                        {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                    </button>
                    <Button onClick={onRunAudit} className="bg-white text-black font-bold uppercase tracking-widest hover:bg-gray-200 rounded-sm px-6" data-testid="nav-free-audit">
                        Free Audit
                    </Button>
                </div>
            </div>
            {/* Mobile dropdown */}
            {open && (
                <div className="md:hidden border-t border-white/5 bg-black/95 backdrop-blur-lg" data-testid="page-mobile-menu">
                    <div className="flex flex-col p-4 space-y-3">
                        {NAV_LINKS.map(l => (
                            <button
                                key={l.key}
                                onClick={() => navigate(l.key)}
                                className={`text-left py-2 px-3 rounded-lg transition-colors ${l.key === activePage ? 'text-magenta font-medium bg-white/5' : 'text-gray-300 hover:text-white hover:bg-white/5'}`}
                            >
                                {l.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </nav>
    );
}
